/* Ishwar Tattva home page: lighter first load, and slider photos that zoom on phones (2026-10-20).
   1. Hero slides after the first, and collection banners off to the side, arrive as <template data-itx-defer>
      and are put in only when they are about to show, so the first screen downloads one hero photo, not five.
   2. On touch screens the photo in the middle of each slider zooms in gently, as it does on mouse-over on desktop.
   Delete this file and its script tags in sections/itx-hero.liquid and sections/itx-stage.liquid to switch it off
   (also remove the <template data-itx-defer> wrappers there). */
(function(){
  if(window.itxSmooth)return;window.itxSmooth=1;
  var d=document,w=window;
  var reduce=w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var touch=w.matchMedia('(hover: none)').matches;
  var loaded=d.readyState==='complete';
  w.addEventListener('load',function(){loaded=true});

  function fill(slide){if(!slide)return;var t=slide.querySelector('template[data-itx-defer]');if(t)t.parentNode.replaceChild(t.content.cloneNode(true),t)}
  function onIndex(slides){for(var k=0;k<slides.length;k++)if(slides[k].classList.contains('is-on'))return k;return 0}

  /* Hero: the showing slide always has its photo; the next one is fetched once the page has finished loading */
  function hero(el){
    if(el.dataset.itxDf)return;el.dataset.itxDf=1;
    var s=el.querySelectorAll('.itx-hero__slide'),n=s.length;if(n<2)return;
    function near(){var k=onIndex(s);fill(s[k]);if(loaded)fill(s[(k+1)%n])}
    new MutationObserver(near).observe(el,{attributes:true,subtree:true,attributeFilter:['class']});
    function later(){setTimeout(function(){loaded=true;near()},400)}
    if(d.readyState==='complete')later();else w.addEventListener('load',later);
  }

  /* Collection banners: the one in front, its neighbours and the next to come in, once the section is close */
  function stage(el){
    if(el.dataset.itxDf)return;el.dataset.itxDf=1;
    var s=el.querySelectorAll('.itx-stage__slide'),n=s.length,on=false;if(!n)return;
    function near(){if(!on)return;var k=onIndex(s);fill(s[k]);fill(s[(k+1)%n]);fill(s[(k+n-1)%n]);fill(s[(k+2)%n])}
    new MutationObserver(near).observe(el,{attributes:true,subtree:true,attributeFilter:['class']});
    if('IntersectionObserver' in w)new IntersectionObserver(function(es){if(es[0].isIntersecting){on=true;near()}},{rootMargin:'300px 0px'}).observe(el);
    else{on=true;near()}
  }

  /* Phones: the card nearest the middle of a sliding row gets .is-mid, and its photo zooms in (itx-polish.css) */
  function mid(el){
    if(el.dataset.itxMid)return;el.dataset.itxMid=1;
    var strip=el.hasAttribute('data-itx-strip'),vis=false,cur=null,next=0;
    function frame(t){
      if(vis&&t>=next){next=t+120;
        var r=el.getBoundingClientRect(),cx=r.left+r.width/2,best=null,bd=1e9,items=strip?el.querySelectorAll('a'):el.children;
        for(var k=0;k<items.length;k++){var b=items[k].getBoundingClientRect();if(!b.width)continue;var dd=Math.abs(b.left+b.width/2-cx);if(dd<bd){bd=dd;best=items[k]}}
        if(best!==cur){if(cur)cur.classList.remove('is-mid');if(best)best.classList.add('is-mid');cur=best}
      }
      if(vis)requestAnimationFrame(frame);
    }
    if('IntersectionObserver' in w)new IntersectionObserver(function(es){var was=vis;vis=es[0].isIntersecting;if(vis&&!was)requestAnimationFrame(frame)},{threshold:.2}).observe(el);
    else{vis=true;requestAnimationFrame(frame)}
  }

  function init(scope){
    scope=scope||d;
    scope.querySelectorAll('.itx-hero').forEach(hero);
    scope.querySelectorAll('[data-itx-stage]').forEach(stage);
    if(touch&&!reduce)scope.querySelectorAll('.itx-rail,[data-itx-strip]').forEach(mid);
  }
  if(d.readyState==='loading')d.addEventListener('DOMContentLoaded',function(){init()});else init();
  d.addEventListener('shopify:section:load',function(e){init(e.target)});
})();
